export default "__VITE_ASSET__6decd6c0__"